import React from 'react';
import useSWR from 'swr';

import { useHandleSWR } from '~/libs/helpers'
import useGlobalState from '~/libs/context';

import TaxReturnImage from '~/public/official-docs/tax-return-reiwa-4.png';
import { LabelCell, LabelVerticalCell, RawValueCell, ValueCell } from '../styles/StyledTaxReturn';
import { OfficialDocumentContainer } from './OfficialDocumentContainer';

const TaxReturn_4 = ({ isEnglish }) => {
	const { year } = useGlobalState(); 
	const { data: swrBalanceSheet } = useSWR(`/api/metrics/balanceSheet?year=${year}`);
  const { data: balanceSheet } = useHandleSWR(swrBalanceSheet, { assets: [], liabilities: [], totals: [] }, true);
  // TODO: Maybe we should find a way to get the totals directly from balanceSheet to avoid two requests
  const { data: swrProfitLoss } = useSWR(`/api/metrics/profitLoss?year=${year}`);
  const { data: profitLoss } = useHandleSWR(swrProfitLoss, { totals: [] }, true);
  const force = isEnglish;
  
  const rowHeight = 3.215;
  const extraAssetsRows = [0, 1, 2, 3, 4, 5, 6];
  const extraLiabilitiesRows = [0, 1, 2, 3, 4, 5, 6];
  const extraLiabilitiesExtraRows = [0, 1, 2, 3, 4, 5, 6];
  const extraProductionCostRows = [0, 1, 2, 3, 4, 5, 6, 7];

	return (
    <OfficialDocumentContainer image={TaxReturnImage}>

      {/* Left section */}

      {/* Column labels */}
      <LabelCell en={"Assets"} coords={[8.85, 4.5]} width={31.8} height={2.65} force={force} />

      {/* Row 1 */}
      <LabelCell en={"Name"} coords={[12.05, 4.5]} width={10.3} height={2.65} force={force} />
      <LabelCell en={"Amount"} coords={[12.05, 15.25]} width={10.35} height={2.65} force={force} />
      <LabelCell en={"Amount (future)"} coords={[12.05, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 2 */}
      <LabelCell en={"Cash"} coords={[15.26, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[15.26, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[15.26, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 3 */}
      <LabelCell en={"Current Bank Account"} coords={[18.47, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[18.47, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[18.47, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 4 */}
      <LabelCell en={"Time deposit"} coords={[21.68, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[21.68, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[21.68, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 5 */}
      <LabelCell en={"Other deposits"} coords={[24.89, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[24.89, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[24.89, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 6 */}
      <LabelCell en={"Notes receivable (short term -1year)"} coords={[28.1, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[28.1, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[28.1, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 7 */}
      <LabelCell en={"Accounts receivable"} coords={[31.31, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[31.31, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[31.31, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 8 */}
      <LabelCell en={"Prepayment"} coords={[34.52, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[34.52, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[34.52, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 9 */}
      <LabelCell en={"Inventory"} coords={[37.73, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[37.73, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[37.73, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 10 */}
      <LabelCell en={"Securities"} coords={[40.94, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[40.94, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[40.94, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 11 */}
      <LabelCell en={"Loan (long term +1year)"} coords={[44.15, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[44.15, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[44.15, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 12 */}
      <LabelCell en={"Building"} coords={[47.36, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[47.36, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[47.36, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 13 */}
      <LabelCell en={"Building equipment"} coords={[50.57, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[50.57, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[50.57, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 14 */}
      <LabelCell en={"Machine"} coords={[53.78, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[53.78, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[53.78, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 15 */}
      <LabelCell en={"Vehicle"} coords={[56.99, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[56.99, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[56.99, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 16 */}
      <LabelCell en={"Tool equipment"} coords={[60.2, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[60.2, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[60.2, 26]} width={10.3} height={2.65} force={force} />

      {/* Row 17 */}
      <LabelCell en={"Land"} coords={[63.41, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[63.41, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[63.41, 26]} width={10.3} height={2.65} force={force} />

      {/* Extra rows */}
      {extraAssetsRows.map(x => <>
        <LabelCell en={""} coords={[rowHeight * x + 66.62, 4.5]} width={10.3} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 66.62, 15.25]} width={10.35} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 66.62, 26]} width={10.3} height={2.65} force={force} />
      </>)}

      {/* Row 25 */}
      <LabelCell en={"To owner / Business advance"} coords={[89.1, 4.5]} width={10.3} height={2.65} force={force} />

      {/* Row 26 */}
      <LabelCell en={"Total"} coords={[92.31, 4.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={0} coords={[92.31, 15.25]} width={10.35} height={2.65} force={force} />
      <RawValueCell value={0} coords={[92.31, 26]} width={10.3} height={2.65} force={force} />

      {/* Center section */}

      {/* Column labels */}
      <LabelCell en={"Liabilities"} coords={[8.85, 36.8]} width={31.8} height={2.65} force={force} />

      {/* Row 1 */}
      <LabelCell en={"Name"} coords={[12.05, 36.8]} width={10.3} height={2.65} force={force} />
      <LabelCell en={"Amount"} coords={[12.05, 47.5]} width={10.3} height={2.65} force={force} />
      <LabelCell en={"Amount (future)"} coords={[12.05, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 2 */}
      <LabelCell en={"Notes payable (short term -1year)"} coords={[15.26, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[15.26, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[15.26, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 3 */}
      <LabelCell en={"Accounts payable"} coords={[18.47, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[18.47, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[18.47, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 4 */}
      <LabelCell en={"Loan (long term +1year)"} coords={[21.68, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[21.68, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[21.68, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 5 */}
      <LabelCell en={"Accrued expenses"} coords={[24.89, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[24.89, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[24.89, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 6 */}
      <LabelCell en={"Advanced Payment"} coords={[28.1, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[28.1, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[28.1, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 7 */}
      <LabelCell en={"Deposit Received"} coords={[31.31, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[31.31, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[31.31, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Extra rows */}
      {extraLiabilitiesRows.map(x => <>
        <LabelCell en={""} coords={[rowHeight * x + 34.52, 36.8]} width={10.3} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 34.52, 47.5]} width={10.3} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 34.52, 58.25]} width={10.3} height={2.65} force={force} />
      </>)}

      {/* Row 15 */}
      <LabelCell en={"Provisions for doubtful sales"} coords={[56.99, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[56.99, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[56.99, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Extra rows */}
      {extraLiabilitiesExtraRows.map(x => <>
        <LabelCell en={""} coords={[rowHeight * x + 60.2, 36.8]} width={10.3} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 60.2, 47.5]} width={10.3} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 60.2, 58.25]} width={10.3} height={2.65} force={force} />
      </>)}

      {/* Row 23 */}
      <LabelCell en={"Initial Deposit"} coords={[82.7, 36.8]} width={10.3} height={2.65} force={force} />

      {/* Row 24 */}
      <LabelCell en={"Result before Special Deduction"} coords={[85.91, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[85.91, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[85.91, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Row 25 */}
      <LabelCell en={"Personal Advance"} coords={[89.12, 36.8]} width={10.3} height={2.8} force={force} />

      {/* Row 26 */}
      <LabelCell en={"Total"} coords={[92.33, 36.8]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[92.33, 47.5]} width={10.3} height={2.65} force={force} />
      <RawValueCell value={null} coords={[92.33, 58.25]} width={10.3} height={2.65} force={force} />

      {/* Right section */}

      {/* Column labels */}
      <LabelCell en={"Cost of production"} coords={[8.85, 70.4]} width={14.3} height={2.65} force={force} />
      <LabelCell en={"Amount"} coords={[8.85, 85.2]} width={10.3} height={2.65} force={force} />

      <LabelVerticalCell en={"Raw materials"} coords={[12.05, 70.4]} width={1.15} height={15.35} force={force} />
      <LabelVerticalCell en={"Other"} coords={[31.31, 70.4]} width={1.15} height={47.5} force={force} />

      {/* Row 1 */}
      <LabelCell en={"Inventory (Beginning) "} coords={[12.05, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[12.05, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 2 */}
      <LabelCell en={"Purchase of goods"} coords={[15.26, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[15.26, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 3 */}
      <LabelCell en={"Sub total ①+②"} coords={[18.47, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[18.47, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 4 */}
      <LabelCell en={"Inventory (Ending) "} coords={[21.68, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[21.68, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 5 */}
      <LabelCell en={"Total ③-④"} coords={[24.89, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[24.89, 85.2]} width={10.3} height={2.65} force={force} />
      
      {/* Row 6 */}
      <LabelCell en={"Labor cost"} coords={[28.1, 70.38]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[28.1, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 7 */}
      <LabelCell en={"Subcontracting"} coords={[31.31, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[31.31, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 8 */}
      <LabelCell en={"Electricity"} coords={[34.52, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[34.52, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 9 */}
      <LabelCell en={"Other utilities"} coords={[37.73, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[37.73, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 10 */}
      <LabelCell en={"Repairs"} coords={[40.94, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[40.94, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 11 */}
      <LabelCell en={"Amortization"} coords={[44.15, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[44.15, 85.2]} width={10.3} height={2.65} force={force} />
      
      {/* Extra rows */}
      {extraProductionCostRows.map(x => <>
        <LabelCell en={""} coords={[rowHeight * x + 47.36, 71.95]} width={11} height={2.65} force={force} />
        <RawValueCell value={null} coords={[rowHeight * x + 47.36, 85.2]} width={10.3} height={2.65} force={force} />
      </>)}

      {/* Row 20 */}
      <LabelCell en={"Misc"} coords={[73.05, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[73.05, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 21 */}
      <LabelCell en={"Total"} coords={[76.26, 71.95]} width={11} height={2.65} force={force} />
      <RawValueCell value={null} coords={[76.26, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 22 */}
      <LabelCell en={"Net cost of production"} coords={[79.47, 70.4]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[79.47, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 23 */}
      <LabelCell en={"In process - Beginning"} coords={[82.68, 70.4]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[82.68, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 24 */}
      <LabelCell en={"Sub total"} coords={[85.89, 70.4]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[85.89, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 25 */}
      <LabelCell en={"In process - Ending"} coords={[89.1, 70.4]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[89.1, 85.2]} width={10.3} height={2.65} force={force} />

      {/* Row 26 */}
      <LabelCell en={"Total"} coords={[92.31, 70.4]} width={12.6} height={2.65} force={force} />
      <RawValueCell value={null} coords={[92.31, 85.2]} width={10.3} height={2.65} force={force} />

    </OfficialDocumentContainer>
	);

};

export default TaxReturn_4;